/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetCandleDataOptions, GetCandleDataResponses } from '../types/GetCandleData'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Returns candle data in the requested [start, end) range for the selected resolution, capped to the most recent 5,000 candles per request. Public callers may query data from up to the last month, while authenticated callers may query up to the last six months (requests with invalid credentials will be rejected as unauthorized).
 * @summary Get candlestick data for an orderbook
 * {@link /v1/charts/:order_book_id/candle}
 */
export function getCandleData<ThrowOnError extends boolean = true>(
  options: Options<GetCandleDataOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetCandleDataResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/charts/{order_book_id}/candle',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetCandleDataResponses, ThrowOnError>>,
  )
}
